export const hasTelegramInitData = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const initData = window.Telegram?.WebApp?.initData
  return typeof initData === 'string' && initData.trim().length > 0
}

export const isTelegramMiniApp = (): boolean => hasTelegramInitData()

export const isBrowserAppRuntime = (): boolean => !hasTelegramInitData()
